import { NotificationBar } from '@eventbrite/eds-notification';
import React from 'react';
import {
    EDIT_ORGANIZER_PROFILE,
    NOTIFICATION_BAR_LABEL,
} from '../../components/Header/constants';
import './Banner.scss';

export const Banner: React.FunctionComponent<{
    organizerId: string;
    hasPermissionToEditOrganizationInfo: boolean;
}> = ({ organizerId, hasPermissionToEditOrganizationInfo }) => (
    <>
        {hasPermissionToEditOrganizationInfo && (
            <div className="organizer-profile-new-layout__banner">
                <NotificationBar>
                    {NOTIFICATION_BAR_LABEL}
                    <a href={`/organizations/info/profile/${organizerId}`}>
                        {EDIT_ORGANIZER_PROFILE}
                    </a>
                </NotificationBar>
            </div>
        )}
    </>
);
